<div class="player-overlay-content" (click)="closeTips()"> 
    <h1>Tips</h1>
    <p></p>
        <ul>
            <li>Rotate your phone</li>
            <li>Double tap to zoom</li>
            <li>Record your progress</li>
        </ul>
    
</div>
